/* unplugin-vue-components disabled */import script from "./supplyDailog.vue?vue&type=script&setup=true&lang=js"
export * from "./supplyDailog.vue?vue&type=script&setup=true&lang=js"

import "./supplyDailog.vue?vue&type=style&index=0&id=35399536&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-35399536"]])

export default __exports__